import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

const CAPTIONS = [
  "Gathering this week's activity…",
  "Reviewing meetings and highlights…",
  "Connecting the dots…",
  "Summarizing with AI…",
];

const CAPTION_INTERVAL_MS = 1800;

// Playful loading state for a summary week block: a few shimmer skeleton cards
// plus a caption that cycles through friendly messages while Haiku runs.
const SummaryLoading = () => {
  const [captionIndex, setCaptionIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCaptionIndex((index) => (index + 1) % CAPTIONS.length);
    }, CAPTION_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col gap-4" aria-label="Summary loading">
      <AnimatePresence mode="wait">
        <motion.div
          key={captionIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="text-sm text-gray-500"
        >
          {CAPTIONS[captionIndex]}
        </motion.div>
      </AnimatePresence>
      <div className="flex flex-col gap-3">
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className="rounded-lg border border-gray-100 p-4 animate-pulse"
          >
            <div className="flex items-center gap-2">
              <div className="h-5 w-5 rounded bg-gray-100" />
              <div className="h-4 w-1/3 rounded bg-gray-100" />
            </div>
            <div className="mt-3 h-3 w-full rounded bg-gray-100" />
            <div className="mt-2 h-3 w-2/3 rounded bg-gray-100" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryLoading;
